import HeroBanner from './components/HeroBanner';
import CategorySection from './components/CategorySection';
import FeaturedVideos from './components/FeaturedVideos';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';

export default function Home() {
  const faqStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '51影视网是否需要注册才能观看？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '不需要！51影视网所有影视资源完全免费，无需注册登录即可在线观看。我们致力于为用户提供最便捷的观影体验，打开网站即可畅享高清流畅的影视内容。',
        },
      },
      {
        '@type': 'Question',
        name: '为什么在51影视网观看视频不会卡顿？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51影视网采用了先进的CDN加速技术和智能码率适配系统，能够根据您的网络状况自动调整视频清晰度，确保流畅不缓冲的观影体验。',
        },
      },
      {
        '@type': 'Question',
        name: '51影视网支持哪些设备观看？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51影视网全面支持PC端、平板电脑和手机端观看。我们的网站采用响应式设计，无论在什么设备上都能获得最佳的观看体验。',
        },
      },
      {
        '@type': 'Question',
        name: '51影视网的视频画质如何？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51影视网提供多种清晰度选择，包括高清HD、全高清1080P以及超高清4K画质。您可以根据自己的网络状况和设备性能自由选择最适合的清晰度。',
        },
      },
      {
        '@type': 'Question',
        name: '51影视网的影视资源多久更新一次？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们的内容团队每天24小时不间断更新，热播剧集一般在播出后2小时内即可上线。电影资源也会在院线下映后第一时间更新。',
        },
      },
      {
        '@type': 'Question',
        name: '在51影视网观看视频安全吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '完全安全！51影视网严格遵守国家相关法律法规，所有内容均来自正规渠道。我们的网站采用HTTPS加密传输，不会在您的设备上安装任何恶意软件或收集个人隐私信息。',
        },
      },
    ],
  };

  const websiteStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '51影视网',
    url: 'https://www.51yingshi.com/',
    description: '51影视网提供免费影视在线观看，高清不卡顿，不缓冲流畅体验，海量视频免费看。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.51yingshi.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteStructuredData) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqStructuredData) }}
      />
      <Navbar />
      <main>
        <HeroBanner />
        <CategorySection />
        <FeaturedVideos />
        <LatestUpdates />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}